import ReactPaginate from "react-paginate";
import { useSearchParams } from "react-router-dom";

export default function CustomPagination({ total, limit }) {
  const [searchParams, setSearchParams] = useSearchParams();
  const initialPage = 0;

  const onPageChange = (e) => {
    searchParams.set("page", e.selected + 1);
    setSearchParams(searchParams);
  };

  const pageCount = Math.ceil(total / limit);

  return (
    <div className="row mt-3">
      <div className="col-sm-12 col-md-5">
        <small>Нийт {total} илэрц</small>
      </div>
      <div className="col-sm-12 col-md-7 d-flex justify-content-end">
        <ReactPaginate
          breakLabel="..."
          onPageChange={onPageChange}
          pageRangeDisplayed={3}
          marginPagesDisplayed={1}
          pageCount={pageCount}
          previousLabel={<i className="mdi mdi-chevron-left" />}
          nextLabel={<i className="mdi mdi-chevron-right" />}
          renderOnZeroPageCount={null}
          pageClassName="paginate_button page-item"
          containerClassName="pagination pagination-rounded"
          pageLinkClassName="page-link mx-1"
          nextLinkClassName="page-link mx-1 rounded"
          previousLinkClassName="page-link mx-1 rounded"
          activeClassName="active"
          disabledClassName="disabled"
          initialPage={initialPage}
        />
      </div>
    </div>
  );
}
